import React from "react";
import thanklogo from "../assets/logo/thanklogo.png";
import { Link } from "react-router-dom";

export default function Thank() {
  return (
    <>
    <section>
      <div
        className="container-fluid thank py-4 d-flex align-items-center"
        data-aos="fade-up"
        data-aos-anchor-placement="top-center"
        style={{
          background: "var(--hero_linear)",
        }}
      >
        <div className="container">
          <div
            className="row align-items-center text-center text-md-start"
            style={{
              minHeight: "auto", // mobile default
            }}
          >
            {/* Logo Section */}
            <div className="col-12 col-md-6 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start">
              <img
                src={thanklogo}
                loading='lazy'
                alt="Thank You Logo"
                style={{ height: "75px", maxWidth: "100%", objectFit: "contain" }}
              />
            </div>

            {/* Button Section */}
            <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
              <Link to="/contact" className="nav-link">
                <button type="button" className="btn btn-outline-primary">
                  Contact Us
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* Custom height for larger screens */}
    <style>{`
      @media (min-width: 768px) {
        .thank {
          min-height: 35vh;
        }
      }
    `}</style>
    </>
  );
}
